import React from 'react';
export function TrustBuilder() {
  return <div className="bg-stark-white border-y border-gray-100 py-6 overflow-hidden" data-id="element-248">
      <div className="max-w-7xl mx-auto px-6" data-id="element-249">
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-midnight-navy/60 text-sm font-manrope font-semibold uppercase tracking-widest text-center" data-id="element-250">
          <span data-id="element-251">Built for restaurant operators who are tired of:</span>
          <span className="text-midnight-navy" data-id="element-252">Missing margins</span>
          <span className="text-accent-red" data-id="element-253">•</span>
          <span className="text-midnight-navy" data-id="element-254">Overspending</span>
          <span className="text-accent-red" data-id="element-255">•</span>
          <span className="text-midnight-navy" data-id="element-256">Delayed clarity</span>
          <span className="text-accent-red" data-id="element-257">•</span>
          <span className="text-midnight-navy" data-id="element-258">Manual inventory</span>
          <span className="text-accent-red" data-id="element-259">•</span>
          <span className="text-midnight-navy" data-id="element-260">Zero visibility</span>
        </div>
      </div>
    </div>;
}